import { Box, BoxProps, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

export const PageHeader = ({
  children,
  sx,
  ...props
}: PropsWithChildren<BoxProps>) => (
  <Box
    sx={{
      "&::after": {
        display: "block",
        content: '""',
        borderBottom: (theme) => `4px solid ${theme.palette.secondary.main}`,
        bottom: 0,
        left: 0,
        position: "absolute",
        width: 58,
      },
      paddingBottom: (theme) => theme.spacing(3),
      position: "relative",
      ...sx,
    }}
    {...props}
  >
    <Typography variant="h2" component="h1">
      {children}
    </Typography>
  </Box>
);
